"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FileItem = _interopRequireDefault(require("./FileItem"));

require("./FilesList.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilesList = function FilesList(_ref) {
  var _ref$files = _ref.files,
      files = _ref$files === void 0 ? [] : _ref$files,
      className = _ref.className,
      onRemove = _ref.onRemove;

  var handleDelete = function handleDelete(removedFile) {
    var newFileList = files.filter(function (file) {
      return file.uid !== removedFile.uid;
    });
    onRemove({
      file: removedFile,
      fileList: newFileList
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "FilesList ".concat(className)
  }, files.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "upload-list"
  }, files.map(function (file) {
    return /*#__PURE__*/_react.default.createElement(_FileItem.default, {
      key: file.uid,
      onDelete: function onDelete() {
        return handleDelete(file);
      }
    }, file.name);
  })));
};

FilesList.propTypes = {
  files: _propTypes.default.arrayOf(_propTypes.default.shape({
    uid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    name: _propTypes.default.string
  })),
  className: _propTypes.default.string,
  onRemove: _propTypes.default.func
};
FilesList.defaultProps = {
  files: [],
  className: '',
  onRemove: function onRemove() {}
};
var _default = FilesList;
exports.default = _default;